import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import HomeLanding from "../views/HomeLanding";
import { Helmet } from "react-helmet-async";

export default function Home(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <HomeLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  useEffect(() => {
    document.title =
      "Zanzibar Mission Tour | Experience Tanzania's Rich Heritage and Vibrant Culture";
  }, []);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Zanzibar Mission Tours & Safaris | Experience Tanzania</title>
        <meta
          name="description"
          content="Discover incredible Zanzibar tours, Tanzania safaris, and travel experiences. Book with Zanzibar Mission Tours for unforgettable adventures in East Africa."
        />
        <meta
          name="keywords"
          content="Zanzibar tours, Tanzania safaris, excursions, travel agency, Serengeti safari"
        />
        <meta
          property="og:title"
          content="Zanzibar Mission Tours & Safaris | Experience Tanzania"
        />
        <meta
          property="og:description"
          content="Discover incredible Zanzibar tours, Tanzania safaris, and travel experiences."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://zanzibarmissiontour.com/" />
        <link rel="canonical" href="https://zanzibarmissiontour.com/" />
      </Helmet>
      {view}
    </>
  );
}
